export const beginCheckoutInitialization = (component) => {
	if (component.checkoutInitStarted) return false;
	component.checkoutInitStarted = true;
	return true;
};

export const stripeLoadErrorFired = (state) => !!state.stripeLoadError && !state.stripeInitTimedOut;

export const markStripeInitializationFailure = (state, stage) => {
	state.stripeLoadError = true;
	if (state.reportedInitStage === stage) return false;
	state.reportedInitStage = stage;
	return true;
};

export const stripeInitializationStage = ({ keyPresent, clientSecretPresent, sdkLoaded, loadErrorFired, elementReady }) => {
	if (!keyPresent) return 'missing_key';
	if (!clientSecretPresent) return 'missing_secret';
	if (!sdkLoaded) return 'sdk_unavailable';
	if (loadErrorFired) return 'element_load_error';
	if (!elementReady) return 'element_timeout';
	return null;
};

export const stripeInitializationDiagnostics = (state) => ({
	keyPresent: !!state.keyPresent,
	clientSecretPresent: !!state.clientSecretPresent,
	sdkLoaded: !!state.sdkLoaded,
	elementCreated: !!state.elementCreated,
	elementReady: !!state.elementReady,
	loadErrorFired: !!state.loadErrorFired,
	iframePresent: !!state.iframePresent,
	cspEnforcedScriptViolationSeen: !!state.cspEnforcedScriptViolationSeen,
});
